import type { TikTokPostSettings, TikTokPrivacyLevel } from '../types'

export const TIKTOK_MUSIC_USAGE_URL =
  'https://www.tiktok.com/legal/page/global/music-usage-confirmation/en'
export const TIKTOK_BRANDED_CONTENT_POLICY_URL =
  'https://www.tiktok.com/legal/page/global/bc-policy/en'

export const PRIVACY_LABELS: Record<TikTokPrivacyLevel, string> = {
  PUBLIC_TO_EVERYONE: 'Everyone',
  MUTUAL_FOLLOW_FRIENDS: 'Friends',
  FOLLOWER_OF_CREATOR: 'Followers',
  SELF_ONLY: 'Only you',
}

/** A draft of the settings: the audience stays unset until the user picks it. */
export type TikTokPostSettingsDraft = Omit<TikTokPostSettings, 'privacyLevel'> & {
  privacyLevel?: TikTokPrivacyLevel
}

export const EMPTY_TIKTOK_POST_SETTINGS: TikTokPostSettingsDraft = {
  privacyLevel: undefined,
  allowComment: false,
  allowDuet: false,
  allowStitch: false,
  commercialContent: false,
  brandOrganic: false,
  brandedContent: false,
}

/**
 * Why the draft cannot be sent yet, or null when it can. Mirrors the server's
 * tiktokPostSettingsProblem so the UI never lets a post through that the
 * server would refuse.
 */
export function tiktokPostSettingsProblem(draft: TikTokPostSettingsDraft): string | null {
  if (!draft.privacyLevel) return 'Choose who can view this video.'
  if (draft.commercialContent && !draft.brandOrganic && !draft.brandedContent) {
    return 'You need to indicate if your content promotes yourself, a third party, or both.'
  }
  if (draft.commercialContent && draft.brandedContent && draft.privacyLevel === 'SELF_ONLY') {
    return "Branded content can't be private. Choose a different audience for this video."
  }
  return null
}

export function isCompleteTikTokPostSettings(
  draft: TikTokPostSettingsDraft
): draft is TikTokPostSettings {
  return tiktokPostSettingsProblem(draft) === null
}
